export const generateSavingData = (value, powerUnitPrice) => {
  const t = value ? value : 0;
  const sum = (t * powerUnitPrice) / 1000;
  return sum;
};
